import { ThemeProvider } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { useCurrentTenant } from "@qpr/client-library";
import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import defaultTheme from "./themes/standard-solution-theme.json";

const Theme = (props: React.PropsWithChildren<{ obj?: any }>) => {
  const tenant = useCurrentTenant();
  const { data, isLoading } = useQuery(
    [`theme-${tenant?.symbol}`],
    () => {
      return axios.get("/themes", {
        params: {
          symbol: tenant?.symbol || "",
        },
      });
    },
    {}
  );

  let theme;

  // Comment out following line to use defaulTheme (theme.json file) instead of theme saved to mongo
  // This helps in creating & modifying theme settings as changes to css are visible immediately
  if (!isLoading && data) theme = data?.data.data[0]?.themeOptions;

  const setServerUrls = (themeData: any) => {
    let themeStr = JSON.stringify(themeData);
    themeStr = themeStr
      .split("url(")
      .join(`url(${process.env.REACT_APP_SERVER_URL}`);
    return JSON.parse(themeStr);
  };

  const useDefaultTheme =
    !theme || typeof theme !== "object" || Object.keys(theme).length === 0;

  let themeObj =
    props.obj || setServerUrls(useDefaultTheme ? defaultTheme : theme);

  themeObj = createTheme(themeObj);

  return <ThemeProvider theme={themeObj}>{props.children}</ThemeProvider>;
};

export default Theme;
